import * as React from 'react';
import { connect } from 'react-redux';
import {
  cancelPayment,
  CancelPayment,
  CreateOrderReturn,
  CreateOrderReturnVipps,
} from '../actions/Actions';
import {
  IPayex,
  IPaymentDetails,
  IProductInfo,
  IReferer,
  IState,
  IUserInfo,
  PaymentMethod as PaymentMethodEnum,
} from '../CustomTypes';
import {
  getBasename,
  padWithZerosLengthTwo,
  rgb2hex,
  getRegretFormLink,
} from '../fastflowUtils';
import ErrorReportingService from '../services/ErrorReportingService';
import { bindActionCreators } from 'redux';
import { History } from 'history';
import {
  PaymentMethod,
  StrexPaymentMethod,
  VippsPaymentMethod,
} from '../layout-components';
import {
  Loader,
  Button,
  classNames,
  Padding,
  BorderRadius,
  TextColor,
  TextAlign,
  Margin,
  Display,
  FlexDirection,
  MaxWidth,
  FontWeight,
  FontSize,
  JustifyContent,
  Width,
  FlexWrap,
  RadioButtonGroup,
  BackgroundColor,
  Icon,
  IconName,
  IconSize,
  IconColor,
  IconFlow,
  MinWidth,
  LoaderSize,
  Link,
} from '@snoam/pinata';
import { ChangeEvent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { ClientShortHandName } from '@snoam/mono-scc';

export interface IOwnProps {
  allowedPaymentMethods: PaymentMethodEnum[];
  paymentMethods?: IPaymentDetails[];
  selectedPaymentMethodId?: number;
  companyPaysUrl?: string;
  userLoggedIn?: boolean;
  history: History;
  owningClient?: string;
  addStrexUrl?: string;
  strexAdditionalInformation: boolean;
  setSelectedPaymentMethod?: (p: IPaymentDetails, s?: boolean) => void;
  showSelectPaymentMethodWarning?: boolean;
  showPurchaseFailedWarning?: boolean;
  fetchPayexWidget: any;
  receiptPageUrl: string;
  callCreateOrder: (
    paymentId: string,
    phoneNumber?: string,
  ) => Promise<CreateOrderReturn>;
  onSubmit: (e: any) => void;
}

export interface IActionProps {
  cancelPayment: CancelPayment;
}

export interface IStateProps {
  referer: IReferer;
  payexWidgetUrl?: string;
  productInfo: IProductInfo;
  userInfo: IUserInfo;
  payex: IPayex;
}

export interface ILocalState {
  payexLoading: boolean;
  payexLoadedFor?: string;
  infoExpanded: boolean;
  strexLoading: boolean;
  vippsLoading: boolean;
}

const styleClass = {
  button: classNames(Width.W_FULL, Margin.MX_10),
  container: classNames(BorderRadius.ROUNDED, Margin.MB_6),
  paymentList: classNames(
    Display.FLEX,
    FlexDirection.FLEX_COL,
    Padding.PX_4,
    BackgroundColor.BG_WHITE,
  ),
  warningText: classNames(
    TextColor.TEXT_WARNING,
    TextAlign.TEXT_CENTER,
    Margin.MB_2,
  ),
  disclaimer: classNames(
    Padding.PY_4,
    Padding.PX_4,
    MaxWidth.MAX_W_2XL,
    Margin.MX_AUTO,
    TextColor.TEXT_NEUTRAL_7,
  ),
  mainText: classNames(FontWeight.FONT_BOLD, Display.FLEX, FlexWrap.FLEX_WRAP),
  subtext: classNames(
    FontWeight.FONT_LIGHT,
    FontSize.TEXT_SM,
    TextColor.TEXT_NEUTRAL_7,
  ),
  secondRow: classNames(Display.FLEX, JustifyContent.JUSTIFY_CENTER),
  loader: classNames(Display.FLEX, JustifyContent.JUSTIFY_CENTER, Margin.MY_5),
  payexColor: classNames(Display.HIDDEN, BackgroundColor.BG_PRIMARY_1),
  listitem: classNames(
    Display.FLEX,
    FlexDirection.FLEX_ROW,
    Padding.PL_4,
    Padding.PB_4,
    FontSize.XS_TEXT_SM,
  ),
  iconstyle: classNames(
    Margin.MR_4,
    MinWidth.MIN_W_6,
    IconFlow.INLINE,
    IconSize.BASE,
  ),
};

export interface IProps
  extends IOwnProps,
    IStateProps,
    IActionProps,
    RouteComponentProps<{ paymentMethodId: string }> {}

class PaymentMethods extends React.Component<IProps, ILocalState> {
  public static displayName = 'PaymentMethods';
  myRef: React.RefObject<HTMLDivElement>;
  constructor(props: IProps) {
    super(props);
    this.addCard = this.addCard.bind(this);
    this.cancelPaymentAndReportError =
      this.cancelPaymentAndReportError.bind(this);
    this.goToStrexPayment = this.goToStrexPayment.bind(this);
    this.renderPayex = this.renderPayex.bind(this);
    this.onPayexPaymentFailed = this.onPayexPaymentFailed.bind(this);
    this.onPayexError = this.onPayexError.bind(this);
    this.myRef = React.createRef<HTMLDivElement>();
    this.onChangedPaymentMethod = this.onChangedPaymentMethod.bind(this);
    this.state = {
      infoExpanded: false,
      payexLoadedFor: undefined,
      payexLoading: false,
      strexLoading: false,
      vippsLoading: false,
    };
  }

  public componentDidMount(): void {
    const { paymentMethodId } = this.props.match.params;
    if (paymentMethodId === '-1') {
      this.addCard(false);
    }
  }

  public render() {
    const {
      paymentMethods,
      selectedPaymentMethodId,
      showSelectPaymentMethodWarning,
      showPurchaseFailedWarning,
      productInfo,
      companyPaysUrl,
    } = this.props;
    const { paymentMethodVipps } = productInfo;
    const basename = getBasename();
    const { payexLoadedFor, payexLoading } = this.state;
    const hiddenBgColorDiv = (
      <div ref={this.myRef} className={styleClass.payexColor} />
    );

    const centeredLoader = (
      <div className={styleClass.loader}>
        <Loader text={'Laster'} size={LoaderSize.SMALL} />
      </div>
    );

    const { recurringInfo, cancellationInfo } = this.props.productInfo;

    const paymentDisc = (
      <div className={classNames(Padding.PT_4, Padding.PR_6)}>
        <ul>
          {recurringInfo ? (
            <li className={styleClass.listitem}>
              <Icon
                className={styleClass.iconstyle}
                name={IconName.AUTORENEW}
                color={IconColor.PRIMARY_1}
                screenReaderText={'Ikon som viser at abonnementet fornyes'}
              />
              {recurringInfo}
            </li>
          ) : null}
          {cancellationInfo ? (
            <li className={styleClass.listitem}>
              <Icon
                className={styleClass.iconstyle}
                name={IconName.TODAY}
                color={IconColor.PRIMARY_1}
              />
              {cancellationInfo}
            </li>
          ) : null}
        </ul>
      </div>
    );

    const consentCard = (
      <div className={Padding.PR_6}>
        <ul>
          <li className={styleClass.listitem}>
            <Icon
              className={styleClass.iconstyle}
              name={IconName.CHECK}
              color={IconColor.PRIMARY_1}
            />
            Betaling med kort samtykker til gjentatt betaling for dette
            abonnementet.
          </li>
        </ul>
      </div>
    );

    const consentPayex = (
      <div className={Padding.PR_6}>
        <ul>
          <li className={styleClass.listitem}>
            <Icon
              className={styleClass.iconstyle}
              name={IconName.CHECK}
              color={IconColor.PRIMARY_1}
            />
            Ved å betale med mobil samtykker jeg til at mobilregning blir brukt
            i denne og fremtidige transaksjoner for dette abonnementet
          </li>
        </ul>
      </div>
    );

    const regretCard = (
      <div className={Padding.PR_6}>
        <ul>
          <li className={styleClass.listitem}>
            <Icon
              className={styleClass.iconstyle}
              name={IconName.INFO_OUTLINE}
              color={IconColor.PRIMARY_1}
            />
            <span>
              Du kan angre kjøpet innen 14 dager ved å sende oss dette{' '}
              <Link
                href={getRegretFormLink(
                  this.props.productInfo.owningClient as ClientShortHandName,
                )}
                target="_blank"
              >
                skjemaet
              </Link>
              . Informasjon om reklamasjon finner du i abonnementsvilkårene.
            </span>
          </li>
        </ul>
      </div>
    );

    const consentVipps = (
      <div className={Padding.PR_6}>
        <ul>
          <li className={styleClass.listitem}>
            <Icon
              className={styleClass.iconstyle}
              name={IconName.CHECK}
              color={IconColor.PRIMARY_1}
            />
            Ved å betale med Vipps samtykker jeg til at Vippsbetaling blir brukt
            i denne og fremtidige transaksjoner for dette abonnementet
          </li>
        </ul>
      </div>
    );

    const consentCompanyPays = (
      <div className={Padding.PR_6}>
        <ul>
          <li className={styleClass.listitem}>
            <Icon
              className={styleClass.iconstyle}
              name={IconName.CHECK}
              color={IconColor.PRIMARY_1}
            />
            Om arbeidsgiver har gitt tillatelse til å kjøpe abonnement hos oss
            kan du sende fakturaen rett til arbeidsgiver
          </li>
        </ul>
      </div>
    );

    // Existing cards
    const existingPayexCards = paymentMethods
      .filter((m) => m.type === 'PAYEX')
      .map((m) => {
        const maskedNumber = m.details.maskedNumber
          .replace(/(.{4})/g, '$1 ')
          .trim();
        const expiryDateJsonOrArray = m.details.expiryDate;
        let { month, year } = expiryDateJsonOrArray;
        if (
          !month &&
          !year &&
          Array.isArray(expiryDateJsonOrArray) &&
          expiryDateJsonOrArray.length === 3
        ) {
          year = expiryDateJsonOrArray[0];
          month = expiryDateJsonOrArray[1];
        }

        const expiryDate = `${padWithZerosLengthTwo(
          month,
        )}/${padWithZerosLengthTwo(year)}`;

        // Payex script finds this div based on Id, and fills it
        const payexContainer = (
          <div
            className={classNames(Width.W_FULL, Padding.PY_4, Padding.PX_4)}
            id={`payexId-${m.id}`}
          />
        );

        return (
          <PaymentMethod
            key={m.id}
            paymentDetails={m}
            selectedPaymentMethodId={selectedPaymentMethodId}
            secondRow={
              <>
                {hiddenBgColorDiv}
                {paymentDisc}
                {consentCard}
                {regretCard}
                {!payexLoading && payexLoadedFor !== m.id.toString() ? (
                  <div className={styleClass.secondRow} id={`div-${m.id}`}>
                    <Button
                      onClick={(e: any) => this.callCreateOrder(e)}
                      data-id={m.id}
                      text={'Bestill'}
                      data-testing={'payment-methods-order-button'}
                      className={styleClass.button}
                    />
                  </div>
                ) : (
                  ''
                )}
                {payexLoading && centeredLoader}
                {payexContainer}
              </>
            }
            textElements={
              <div>
                <div className={styleClass.mainText}>{maskedNumber}</div>
                <div className={styleClass.subtext}>Utløper {expiryDate}</div>
              </div>
            }
            image={
              <img
                src={`${basename}img/card-${m.details.paymentMethod.toUpperCase()}.png`}
                alt={m.details.paymentMethod}
              />
            }
          />
        );
      });

    // New card
    const newCardWidget = (
      <PaymentMethod
        key={-1}
        paymentDetails={{ id: -1, type: 'PAYEX' }}
        selectedPaymentMethodId={selectedPaymentMethodId}
        secondRow={
          <>
            {hiddenBgColorDiv}
            {paymentDisc}
            {regretCard}
            {payexLoading ? centeredLoader : null}
            <div
              id="payexId"
              className={classNames(Width.W_FULL, Padding.PY_4, Padding.PX_4)}
            />
          </>
        }
        textElements={
          <div>
            <div className={styleClass.mainText}>Legg til kort</div>
            <div className={styleClass.subtext}>Kredit eller debet</div>
          </div>
        }
        image={<img src={`${basename}img/addcard.png`} alt="Add card" />}
      />
    );

    const addStrexWidget = (
      <StrexPaymentMethod // STREX
        callCreateOrder={this.callCreateOrderOnStrex}
        paymentDetails={{ id: -2, type: 'STREX' }}
        price={this.props.productInfo.price}
        selectedPaymentMethodId={selectedPaymentMethodId}
        userInfo={this.props.userInfo}
        disclaimer={
          <>
            {paymentDisc}
            {consentPayex}
            {regretCard}
          </>
        }
      >
        <div>
          <div className={styleClass.mainText}>Betal via mobilregningen</div>
          <div className={styleClass.subtext}>Strex telefonregning</div>
        </div>
        <div className={Margin.ML_AUTO}>
          <img src={`${basename}img/addstrex.png`} alt="STREX" />
        </div>
      </StrexPaymentMethod>
    );

    const addVippsWidget = paymentMethodVipps ? (
      <VippsPaymentMethod
        callCreateOrder={this.callCreateOrderOnVipps}
        loading={this.state.vippsLoading}
        paymentDetails={{ id: -4, type: 'VIPPS_RECURRING' }}
        selectedPaymentMethodId={selectedPaymentMethodId}
        userInfo={this.props.userInfo}
        disclaimer={
          <>
            {paymentDisc}
            {consentVipps}
            {regretCard}
          </>
        }
      >
        <div>
          <div className={styleClass.mainText}>Betal via Vipps</div>
          <div className={styleClass.subtext}>Vippsbetaling</div>
        </div>
        <div className={Margin.ML_AUTO}>
          <img src={`${basename}img/VIPPS.png`} alt="Vipps" />
        </div>
      </VippsPaymentMethod>
    ) : null;

    const companyPaysWidget = productInfo.paymentMethodCompanyPays && (
      <PaymentMethod // Company pays
        key={-3}
        paymentDetails={{ id: -3, type: 'COMPANYPAYS' }}
        onKeyDown={this.keyDownHandlerCompanyPays}
        selectedPaymentMethodId={selectedPaymentMethodId}
        secondRow={
          <div className={classNames(Width.W_FULL, Padding.PB_4)}>
            {paymentDisc}
            {consentCompanyPays}
            <div className={styleClass.secondRow}>
              <Button
                onClick={() => this.props.history.push(companyPaysUrl)}
                onKeyDown={this.keyDownHandlerCompanyPays}
                text={'Send faktura til arbeidsgiver'}
                className={styleClass.button}
              />
            </div>
          </div>
        }
        textElements={
          <div>
            <div className={styleClass.mainText}>Faktura til arbeidsgiver</div>
            <div className={styleClass.subtext}>Organisasjonsnummer</div>
          </div>
        }
        image={
          <img
            src={`${basename}img/option_businessinfo.svg`}
            alt="COMPANYPAYS"
          />
        }
      />
    );

    const allowsPayex = this.props.allowedPaymentMethods.includes(
      PaymentMethodEnum.PAYEX,
    );
    const allowsStrex = this.props.allowedPaymentMethods.includes(
      PaymentMethodEnum.STREX,
    );
    const allowsVipps = this.props.allowedPaymentMethods.includes(
      PaymentMethodEnum.VIPPS,
    );
    return (
      <div className={styleClass.container}>
        {showSelectPaymentMethodWarning && (
          <div className={styleClass.warningText}>
            Vennligst velg betalingsmetode
          </div>
        )}
        {showPurchaseFailedWarning && (
          <div className={styleClass.warningText}>
            Beklager, men vi klarte ikke å trekke penger på valgt kort. Sjekk at
            det er dekning på konto, eller legg til et nytt kort.
          </div>
        )}
        <RadioButtonGroup
          name="paymentmethod"
          value={'' + selectedPaymentMethodId}
          onChange={this.onChangedPaymentMethod}
        >
          <div className={styleClass.paymentList}>
            {allowsVipps && addVippsWidget}
            {paymentMethods && allowsPayex && existingPayexCards}
            {allowsPayex && newCardWidget}
            {allowsStrex && addStrexWidget}
            {companyPaysWidget}
          </div>
        </RadioButtonGroup>
      </div>
    );
  }

  private keyDownHandlerStrex = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter') {
      this.props.onSubmit(e);
    }
  };

  private keyDownHandlerCompanyPays = (
    e: React.KeyboardEvent<HTMLAnchorElement>,
  ) => {
    if (e.key === 'Enter') {
      this.props.history.push(this.props.companyPaysUrl);
    }
  };

  private callCreateOrderOnStrex = (paymentId: string): void => {
    this.setState({
      strexLoading: true,
    });
    this.props.callCreateOrder(paymentId).then((data) => {
      this.setState({ strexLoading: false });
      if (data) {
        if ('paymentId' in data && data.paymentId) {
          (window as any).paymentId = data.paymentId;
        }
        this.props.history.replace(
          `${this.props.receiptPageUrl}&subscriptionId=${
            (data && 'subscriptionId' in data && data.subscriptionId) || ''
          }`,
        );
      }
    });
  };

  private callCreateOrderOnVipps = (phoneNumber: string): void => {
    this.setState({ vippsLoading: true });
    this.props
      .callCreateOrder('-4', phoneNumber)
      .then((data) => {
        this.setState({ vippsLoading: false });
        if (data) {
          return Promise.resolve(data as CreateOrderReturnVipps);
        } else {
          return Promise.reject(
            new Error('Got empty response from createOrder'),
          );
        }
      })
      .then((data) => {
        window.location.assign(data.redirectUrl);
      })
      .catch((e) => {
        console.log('catch, e: ', e);
        const message = (() => {
          try {
            return JSON.parse(e.data).errorContext.error;
          } catch (ignored) {
            return e.toString();
          }
        })();
        this.setState({ vippsLoading: false });
        ErrorReportingService.reportMessage(message);
      });
  };

  private callCreateOrder = (e: Event | number) => {
    const id = (e as any).currentTarget.dataset.id || e;
    if ((e as any).currentTarget) {
      (e as any).preventDefault();
      (e as any).hidden = true;
    }
    this.setState({
      payexLoading: true,
      strexLoading: this.props.selectedPaymentMethodId === -2,
      vippsLoading: this.props.selectedPaymentMethodId === -4,
    });
    this.props
      .callCreateOrder(id)
      .then((data: any) => {
        this.setState({
          payexLoading: false,
          payexLoadedFor: id,
          vippsLoading: false,
        });
        if (data && data.widgetUrl) {
          if (data.paymentId) {
            (window as any).paymentId = data.paymentId;
          }
          this.renderPayex(id, data.widgetUrl);
        } else {
          this.props.history.replace(
            `${this.props.receiptPageUrl}&subscriptionId=${
              (data && data.subscriptionId) || ''
            }`,
          );
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  };

  private goToStrexPayment(e: Event) {
    e.preventDefault();
    window.location.href = this.props.addStrexUrl;
  }

  private addCard(shouldSendPulseEvent: boolean = true) {
    this.setState({ payexLoading: true, payexLoadedFor: undefined });
    const { paymentMethodId } = this.props.match.params;
    if (paymentMethodId !== '-1') {
      this.props.setSelectedPaymentMethod(
        { id: -1, type: 'PAYEX' },
        shouldSendPulseEvent,
      );
    }
    if (paymentMethodId !== undefined) {
      this.props
        .fetchPayexWidget()
        .then((data: any) => {
          if (data.paymentId) {
            (window as any).paymentId = data.paymentId;
          }
          this.renderPayex(undefined, data.widgetUrl);
          this.setState({ payexLoading: false });
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .catch((e) => {
          this.setState({ payexLoading: false, payexLoadedFor: undefined });
        });
    }
  }

  private onPaymentCompleted(compeleted: any) {
    // This is ready if we want to add a hook when payment is completed in widget
    let p = (window as any).paymentId;
    if (p === undefined) {
      p = '';
    }
    window.location.href = compeleted.redirectUrl + '&paymentId=' + p;
  }

  private onPayexPaymentFailed(error: any) {
    this.cancelPaymentAndReportError('onPayexPaymentFailed', error);
  }

  private onPayexError(error: any) {
    this.cancelPaymentAndReportError('onPayexError', error);
  }

  private cancelPaymentAndReportError(methodName: string, error: any) {
    const message = `${methodName}: ${JSON.stringify(error)} spidId: ${
      this.props.userInfo.spidId
    } paymentMethodId: ${this.props.selectedPaymentMethodId}`;
    this.props.cancelPayment(
      this.props.productInfo.owningClient,
      this.props.userInfo.spidId,
      this.props.userInfo.sig,
      message,
    );
    ErrorReportingService.reportMessage(message);
  }

  private renderPayex(id?: string, widgetUrl?: string) {
    const payexId = id ? `payexId-${id}` : 'payexId';
    const el = document.getElementById(payexId);
    if (!el) {
      return null;
    }
    if (el && el.children.length > 0) {
      return null;
    }
    const oldScript = document.getElementById('payexScript');
    if (oldScript) {
      document.body.removeChild(oldScript);
    }
    const payexButtonColor = this.myRef.current
      ? rgb2hex(
          window
            .getComputedStyle(this.myRef.current)
            .getPropertyValue('background-color'),
        )
      : '';

    const script = document.createElement('script');
    script.setAttribute('id', 'payexScript');
    script.src = widgetUrl ? widgetUrl : this.props.payexWidgetUrl;
    script.async = true;
    script.onload = () => {
      (window as any).payex.hostedView
        .creditCard({
          container: payexId,
          onError: this.onPayexError,
          onPaymentCompleted: this.onPaymentCompleted,
          onPaymentFailed: this.onPayexPaymentFailed,
          style: {
            button: {
              backgroundColor: payexButtonColor, //BackgroundColor.BG_PRIMARY1 fetched from hidden div
            },
            body: {
              backgroundColor: '#F8F9FB', //bg-neutral-1
            },
            formGroup: {
              backgroundColor: '#F8F9FB', //bg-neutral-1
            },
          },
        })
        .open();
    };
    document.body.appendChild(script);
    return null;
  }

  /** Payex styling options:
 * {
    style: {
        body: {
            backgroundColor: "#555",
            color: "#bbb"
        },
        button: {
            backgroundColor: "#36ac4c",
            color: "#fff"
        },
        secondaryButton: {
            backgroundColor: "#555",
            border: "solid 1px #bbb"
        },
        formGroup: {
            color: "#bbb",
            backgroundColor: "#555"
        },
        label: {
            color: "#bbb"
        }
    }
 */

  private onChangedPaymentMethod(e: ChangeEvent<HTMLInputElement>) {
    const value = e.target.value;
    if (value === '-1') {
      this.addCard();
    } else if (value === '-2') {
      this.props.setSelectedPaymentMethod({
        id: -2,
        type: 'STREX',
      });
    } else if (value === '-3') {
      this.props.setSelectedPaymentMethod({
        id: -3,
        type: 'COMPANYPAYS',
      });
    } else if (value === '-4') {
      this.props.setSelectedPaymentMethod({
        id: -4,
        type: 'VIPPS_RECURRING',
      });
    } else {
      const cardExists = this.props.paymentMethods.find(
        (method) => method.id === +value,
      );
      if (cardExists) {
        this.props.setSelectedPaymentMethod(cardExists);
      }
    }
  }
}

export default withRouter(
  connect<IStateProps, IActionProps, IOwnProps>(
    (state: IState) =>
      ({
        payex: state.payex,
        productInfo: state.productInfo,
        referer: state.referer,
        userInfo: state.userInfo,
      }) as IStateProps,
    (dispatch) =>
      bindActionCreators(
        {
          cancelPayment,
        },
        dispatch,
      ) as IActionProps,
  )(PaymentMethods),
);
